import { createContext, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LangContext = createContext({});

export function LangProvider({ children }) {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState(localStorage.getItem('jadwil_lang') || 'ar');

  useEffect(() => {
    i18n.changeLanguage(lang);
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [lang, i18n]);

  const toggleLang = () => {
    const newLang = lang === 'ar' ? 'en' : 'ar';
    setLang(newLang);
    localStorage.setItem('jadwil_lang', newLang);
  };

  const isRtl = lang === 'ar';

  return (
    <LangContext.Provider value={{ lang, toggleLang, isRtl }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
